import React, { PureComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Table } from "reactstrap";
import PrintFooter from "../../../common/component/PrintFooter";
import PrintHeader from "../../../common/component/PrintHeader";
import { showCurrency, showQty } from "../../../common/function/showValueHelper";

type SOBerkatPrintProps = {
    data: any;
    companyInfo: any;
    settingHargaSatuan: boolean;
};

class SOBerkatPrint extends PureComponent<WithTranslation & SOBerkatPrintProps> {
    render() {
        const { t } = this.props;
        const { companyInfo, data } = this.props;
        if (data == null) return <p>No Data</p>;
        let columns = data.detailList.map((obj: any, index: number) => {
            return (
                <tr key={"detail-" + index}>
                    <td className="rowNo">{index + 1}</td>
                    <td>{obj.productName ?? obj.product.name}</td>
                    <td className="qty">
                        {obj.unit == null ? (
                            <table className="printQtyTable">
                                <tbody>
                                    <tr key={"detail-1-" + index}>
                                        <td>{showQty(obj.qty) + " "}</td>
                                        <td>{obj.product?.unit?.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <table className="printQtyTable">
                                <tbody>
                                    <tr key={"detail-1-" + index}>
                                        <td>{showQty(obj.qty) + " "}</td>
                                        <td>{obj.unit.name}</td>
                                    </tr>
                                </tbody>
                            </table>
                        )}
                    </td>
                    <td className="price">{showCurrency(obj.price, 2)}</td>
                    <td className="price">{showCurrency(obj.disc1, 2)}</td>
                    <td className="subTotal">{showCurrency(obj.subtotal, 2)}</td>
                </tr>
            );
        });

        let companyPaymentInfo = companyInfo.find((val: any) => {
            return val.key === "company-payment-info";
        });

        let summaryRow = (
            <Table className="ra-summary-table">
                <tbody>
                    <tr>
                        <td colSpan={4}>
                            <b>{t("common.calculatedPrice")}: </b> <br /> {data.say} Rupiah
                        </td>
                        <td className="disc" style={{ textAlign: "right" }}>
                            {t("common.discount")}
                        </td>
                        <td className="subTotal">{showCurrency(data.disc2AmountTotal)}</td>
                    </tr>
                    <tr>
                        <td rowSpan={4} colSpan={4}>
                            {t("common.notes")}: {data.description}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: "right" }}>{t("common.taxBase")}</td>
                        <td className="subTotal">{showCurrency(data.subtotal, 2)}</td>
                    </tr>
                    <tr>
                        <td style={{ textAlign: "right" }}>{t("common.tax")}</td>
                        <td className="subTotal">{showCurrency(data.vat, 2)}</td>
                    </tr>
                    {data.modifierCoa != null && (
                        <tr>
                            <td style={{ textAlign: "right" }}>{data.modifierCoa.name}</td>
                            <td className="subTotal">{showCurrency(data.modifierAmount, 2)}</td>
                        </tr>
                    )}
                    <tr>
                        <td style={{ textAlign: "right" }}>{t("common.grandTotal")}</td>
                        <td className="subTotal">{showCurrency(data.grandTotal, 2)}</td>
                    </tr>
                </tbody>
            </Table>
        );

        return (
            <Table className="ra-table-print">
                <PrintHeader
                    title={t("common.salesOrder")}
                    companyInfo={companyInfo}
                    customer={data.customer}
                    no={data.key}
                    dtCreated={data.dtCreated}
                />
                <tbody>
                    <tr>
                        <td colSpan={2}>
                            <Table className="ra-table-detail-print">
                                <thead>
                                    <tr>
                                        <th className="rowNo">#</th>
                                        <th>{t("common.product")}</th>
                                        <th className="qty">{t("common.qty")}</th>
                                        <th className="price">{t("common.price")}</th>
                                        <th className="disc">{t("common.discount")}</th>
                                        <th className="subTotal">{t("common.subTotal")}</th>
                                    </tr>
                                </thead>
                                <tbody>{columns}</tbody>
                            </Table>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>{summaryRow}</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            {companyPaymentInfo.value !== "" ? (
                                <>
                                    <strong>{t("common.paymentInfo")}</strong>
                                    <p>{companyPaymentInfo.value}</p>
                                </>
                            ) : (
                                ""
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <PrintFooter status={data.status} />
                        </td>
                    </tr>
                </tbody>
            </Table>
        );
    }
}

export default withTranslation()(SOBerkatPrint);
